import React from "react";
import LoginBanner from "../components/LoginBanner";
import "../../../styles/main.scss";
import "bootstrap/dist/css/bootstrap-reboot.min.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.js";

const Maintenance = () => {
  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-md">
            <LoginBanner />
          </div>
          <div className="col-md login-holder">
            <div
              className="login-box"
              id="log-in"
              style={{ padding: 0, paddingTop: 10 }}
            >
              <div style={{ marginTop: 10 }}>
                <h4
                  style={{
                    color: "#424242",
                    margin: 0,
                    paddingLeft: 10,
                    paddingRight: 10,
                    fontSize: 20
                  }}
                >
                  The portal is currently down for planned maintenance, we’re
                  sorry for any inconvenience this may cause. If you need to
                  access your account please download the app.
                </h4>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: 20
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    justifyContent: "flex-end"
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;



// WEBPACK FOOTER //
// ./src/modules/auth/pages/Maintanance.js